import { useEffect, type FC } from 'react';

import MiuThemeProvider from '@toolbox/style/theme/common/ThemeProvider/ThemeProvider';
import { OverlayCmp } from '@toolbox/components';
import { BREAKPOINTS, useBreakpoint } from '@widget/utils/useBreakpoint';
import { PhoneLinkBtn } from './PhoneLinkBtn';

import type { ButtonProps } from '@mui/material';
import type { PhoneCta } from '@widget/types/PhoneCtaType';

export type PhoneLinkBtnProps = {
  phoneCTA?: PhoneCta | null;
} & Pick<ButtonProps, 'variant' | 'color' | 'sx'>;

export const PhoneLink: FC<{ phoneCTA?: PhoneCta | null }> = ({ phoneCTA }) => {
  const breakpoint = useBreakpoint() || '';
  const isPhoneScreen = [BREAKPOINTS.xs, BREAKPOINTS.sm].includes(breakpoint);

  useEffect(() => {
    if (isPhoneScreen) {
      document.body.style.paddingBottom = '90px';
    } else {
      document.body.style.paddingBottom = '';
    }
  }, [isPhoneScreen]);
  if (!isPhoneScreen) {
    return <PhoneLinkBtn phoneCTA={phoneCTA} variant={'contained'} color={'secondary'} />;
  }
  return (
    <MiuThemeProvider>
      <OverlayCmp showWhenListenerIsInactive={true}>
        <PhoneLinkBtn phoneCTA={phoneCTA} variant={'contained'} color={'secondary'} />
      </OverlayCmp>
    </MiuThemeProvider>
  );
};

export const PhoneLinkMUIWrapper = ({ phoneCTA }: PhoneLinkBtnProps) => {
  return (
    <MiuThemeProvider>
      <PhoneLink phoneCTA={phoneCTA} />
    </MiuThemeProvider>
  );
};
